module.exports = __webpack_public_path__ + "static/bottom-2fc8879956fcb4c7a247142db2a66cf5.jpg";